import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { renderHeaderItem, renderRowItem } from './utils';

const InfoBlock = props => (
  <div className={cx('c-info-block', { 'c-info-block--total': props.kind === 'total' })}>
    <div
      className="c-info-block__title o-flexbox"
      display-if={props.kind === 'info'}
    >
      {props.columns.map(renderHeaderItem)}
    </div>
    <div>
      {props.data.map(renderRowItem(props.columns))}
    </div>
    <div
      className="c-info-block__title o-flexbox"
      display-if={props.kind === 'total'}
    >
      {props.columns.map(renderHeaderItem)}
    </div>
  </div>
);

InfoBlock.defaultProps = {
  kind: 'info',
  columns: [],
  data: [],
};

InfoBlock.propTypes = {
  kind: PropTypes.oneOf(['info', 'total']),
  columns: PropTypes.array,
  data: PropTypes.array,
};

export default InfoBlock;
